import { useEffect } from 'react';
import { useGenerateSession } from '@/services/useGenerateSession';
import { getCookie, setCookie } from '@/utils/functions';
import { loadFromStorage, saveToStorage } from '@/utils/client-storage/localStorage';

export const SessionInitializer = ({ utmTags }: { utmTags: string }) => {
  const { mutate } = useGenerateSession();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const urlId = searchParams.get('id');

    let currentId = getCookie('currentId') || loadFromStorage('currentId');

    if (urlId && urlId !== currentId) {
      // If landing directly via URL with an ID, save it and treat it as the current session
      saveToStorage('currentId', urlId);
      setCookie('currentId', urlId, 7);
      currentId = urlId;
    }

    if (!currentId) {
      mutate({ utmTags });
    }
  }, [mutate, utmTags]);

  return null;
};
